import React, { useState } from "react";
import CommonGrid from '../../../Components/common/CommonGrid'

import Trash from "../../../assets/images/trash.png";
import Info from "../../../assets/images/info.png";
import RedCross from "../../../assets/images/close.png";
import edit from "../../../assets/images/edit.png";

const ModuleUpdate = () => {

    const columns = [
        {
            text: 'Actions',
            cellsrenderer: function () {
                return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /> <img src="' + Info + '" class="row_info" /></div>';
            },
            width: '16%', filterable: false,
        },
        // {
        //     text: 'Name', filtertype: 'textbox', datafield: 'airway_bill', width: '18%', cellclassname: '',
        //     cellclassname: (row, column, value, rowData) => {
        //         if (rowData.colour_status == 'G') {
        //             return "awb_green";
        //         } else if (rowData.colour_status == 'R') {
        //             return "awb_red";
        //         } else if (rowData.colour_status == 'O') {
        //             return "awb_orange";
        //         } else {
        //             return;
        //         }
        //     },
        // },
        { text: 'Name', filtertype: 'textbox', datafield: 'name', width: '18%', cellclassname: '', },
        { text: 'Module', filtertype: 'textbox', datafield: 'import_export', width: '16%', cellclassname: '', },
        { text: 'Updated By', filtertype: 'textbox', datafield: 'connection_flight', width: '16%', cellclassname: '', },
        { text: 'Updated On', filtertype: 'textbox', datafield: 'connection_time', width: '16%', cellclassname: '', },
        { text: 'Status', filtertype: 'textbox', datafield: 'origin', width: '16%', cellclassname: '', },
        // { text: 'Dest.', filtertype: 'textbox', datafield: 'destination', width: '6%', cellclassname: '', },
        // {
        //     text: 'RCS / DEP',
        //     width: '7%',
        //     filterable: false,
        //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowData) {
        //         const pieces = parseFloat(rowData.pieces) || 0;
        //         const rcs = parseFloat(rowData.rcs_total_pieces_awb) || 0;
        //         let displayValue = `<div class="" style="margin-top: 13.5px;"><img src='${RedCross}' alt='Not Received' title='Not Received' /></div>`;
        //         if (rcs > 0) {
        //             displayValue = `${rcs} / ${pieces}`;
        //         }
        //         return `<div class="" style="margin-top: 13.5px;">${displayValue}</div>`;
        //     },
        // },
        // // { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number_join', width: '9%', cellclassname: '', },
        // { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', },
        // { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '7%', cellclassname: '', },
        // { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', },
        // { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '11%', cellclassname: '', },
        // {
        //     text: 'Truck',
        //     datafield: 'truck_no',
        //     filtertype: 'textbox',
        //     width: '9%',
        //     cellclassname: '',
        //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
        //         // if truck_no is empty, null, or undefined, fallback to rowdata.truck
        //         const displayValue = value && value.trim() !== '' ? value : (rowdata.truck || '');
        //         return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;">${displayValue}</div>`;
        //     }
        // }
        // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '11%', cellclassname: '', },

    ];

    const datafields = [
        { name: 'id', type: 'string' },
        { name: 'awb_id', type: 'string' },
        { name: 'airway_bill', type: 'string' },
        { name: 'destination', type: 'string' },
        { name: 'time', type: 'string' },
        { name: 'flight_number_join', type: 'string' },
        { name: 'flight_code', type: 'string' },
        { name: 'flight_number', type: 'string' },
        { name: 'flight_date', type: 'string' },
        { name: 'truck_no', type: 'string' },
        { name: 'truck', type: 'string' },
        { name: 'received', type: 'string' },
        { name: 'pieces', type: 'string' },
        { name: 'weight', type: 'string' },
        { name: 'volume', type: 'string' },
        { name: 'shc', type: 'string' },
        { name: 'commodity', type: 'string' },
        { name: 'connection_time', type: 'string' },
        { name: 'origin', type: 'string' },
        { name: 'rcs_total_pieces_awb', type: 'string' },
        { name: 'bkd', type: 'string' },
        { name: 'colour_status', type: 'string' },
        { name: 'movements', type: 'string' },
        { name: 'differtime', type: 'string' },
        { name: 'import_export', type: 'string' },
        { name: 'connection_flight', type: 'string' },
    ]
    const gridData = {
        Tab: 0,
        Token: `SuperAdminToken`,
        EndPoint: 'get-assigned-awbs',
        Datafields: datafields,
        Columns: columns,
        Options: {
            height: 1040,
            selectionmode: 'checkbox',
        }
    }
    return (
        <>
            <div className='mt-3 position-relative'>
                <div className='bookinggrid' style={{ background: '#fff' }}></div>
            </div>
            {/* <CommonGrid GD={gridData} /> */}
        </>
    )
}

export default ModuleUpdate